// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type SchedulerListe, SchedulerScope } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type SearchSchedulersQuery = {
  search?: string;
  scope?: SchedulerScope;
  mandantId?: string;
  selectableForAufgabe?: string;
  aufgabeId?: string;
  filtered?: string;
  page?: number;
  limit?: number;
  sort?: string;
};

export function useSearchSchedulers(): (
  query: SearchSchedulersQuery
) => Promise<SchedulerListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (query = {}) =>
      (await getAPI()).schedulers.searchSchedulers({ ...query }),
    [getAPI]
  );
}
